import PropTypes from "prop-types";
import React from "react";
import Button from "web/react/components/button/button";
import { connect } from "react-redux";
import withReduxProvider from "web/react/redux-provider";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import MultiplyOnHoverButton from "web/react/components/buttons/multiply-on-hover-button/multiply-on-hover-button";
import { gettext } from "web/script/modules/django-i18n";
import LeadLink from "web/react/components/lead-link/lead-link";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import browser from "web/script/utils/browser";
import styles from "./buy-on-store-button-with-discount.css";

export function BuyOnStoreButtonWithDiscount({
    leadUrl,
    leadLabel,
    discountLabel,
    openCustomerCaptureOverlay,
    productId,
    reason,
    beforeOnClick,
    bingTraffic,
}) {
    function onClickBuyNow() {
        if (!userProfiler.isLoggedIn() && environment.get("boomLeadSignupPrompt")) {
            openCustomerCaptureOverlay({
                productId: productId,
                captureType: "signup_lead_save",
            });
        }
    }

    let isMobile = browser.getViewport() <= browser.VIEWPORTS.TABLET;
    let discountText = isMobile ? " " + discountLabel : " (" + discountLabel + ")";
    let buttonLabel = isMobile ? (
        <div className={styles.mobileButton}>
            <span className={styles.label}> {leadLabel} </span>
            <span className={styles.mobileDiscountText}> {discountText} </span>
        </div>
    ) : (
        <p className={styles.label}>
            {leadLabel}
            <span className={styles.discountText}>{discountText}</span>
        </p>
    );
    let elementType = isMobile ? "span" : "div";

    let button = (
        <MultiplyOnHoverButton
            className={styles.buttonMultiply}
            fullHeight
            fullWidth
            element={elementType}
        >
            {buttonLabel}
        </MultiplyOnHoverButton>
    );

    if (bingTraffic === false) {
        button = (
            <Button styleType="secondary" className={styles.buttonBuyNow} fullHeight fullWidth>
                {buttonLabel}
            </Button>
        );
    }

    return (
        <LeadLink
            beforeOnClick={beforeOnClick}
            afterOnClick={onClickBuyNow}
            href={leadUrl}
            openInNewTab={true}
            productId={productId}
            reason={reason}
        >
            {button}
        </LeadLink>
    );
}

BuyOnStoreButtonWithDiscount.propTypes = {
    leadLabel: PropTypes.string,
    leadUrl: PropTypes.string.isRequired,
    discountLabel: PropTypes.string,
    openCustomerCaptureOverlay: PropTypes.func,
    productId: PropTypes.string.isRequired,
    reason: PropTypes.string,
    beforeOnClick: PropTypes.func,
    bingTraffic: PropTypes.bool,
};

BuyOnStoreButtonWithDiscount.defaultProps = {
    leadLabel: gettext("product.buy_area.shop_now"),
    reason: "buy-on-store-button-with-discount",
};

export default withReduxProvider(
    connect(null, { openCustomerCaptureOverlay })(BuyOnStoreButtonWithDiscount)
);
